import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../api-client';
import { toast } from 'sonner';
import { MY_PICKS_QUERY_KEY, refreshMyPicksCache } from './myPicksCache';

export type SubmitSelectionRequest = {
  selections: Array<{
    question_id: string;
    option_id: string;
  }>;
};

type SubmitSelectionResponse = {
  success: boolean;
};

export const submitSelection = (
  pickemId: string,
  selections: SubmitSelectionRequest['selections']
) => apiClient.post<SubmitSelectionResponse>(`/api/pickems/${pickemId}/selections`, { selections });

export const useSubmitSelectionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      pickemId,
      selections,
    }: {
      pickemId: string;
      selections: SubmitSelectionRequest['selections'];
    }) => submitSelection(pickemId, selections),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: MY_PICKS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: ['squares', 'my-selection'] });
      queryClient.invalidateQueries({ queryKey: ['square'] });
      // Refetch my-picks so My Games shows the new entry immediately
      await refreshMyPicksCache(queryClient);
    },
    onError: (error: any) => {
      toast.error(error?.message || 'Failed to submit selection');
    },
  });
};
